import { Link } from '@inertiajs/react';
import { PropsWithChildren } from 'react';
import Footer from '~/components/application/Footer';
import Logo from '~/components/application/Logo';
import PromoCodeBanner from '~/components/application/PromoCodeBanner';
import SaleBanner from '~/components/application/SaleBanner';
import useFeatureFlags from '~/hooks/useFeatureFlags';
import { rootPath } from '~/routes';

export default function Layout({ children }: PropsWithChildren) {
  const { saleBannerEnabled } = useFeatureFlags();

  return (
    <div className=" flex flex-col min-h-screen">
      {saleBannerEnabled && <SaleBanner />}
      <PromoCodeBanner />

      <header className="relative pt-6 pb-0 pl-6 pr-6 md:pt-10 md:pl-10 md:pr-10 lg:pt-14 lg:pl-14 lg:pr-0">
        <Link alt="Pocket Casts logo" href={rootPath()}>
          <div className="md:hidden">
            <Logo size={48} />
          </div>
          <div className="hidden md:block">
            <Logo size={56} />
          </div>
        </Link>
      </header>

      <div className="flex-1 flex flex-col pl-6 md:pl-10 lg:pl-14 pr-6 md:pr-10 lg:pr-0">
        <main className="flex-1">{children}</main>
        <footer className="py-5 flex items-center">
          <Footer />
        </footer>
      </div>
    </div>
  );
}
